

























































import { ElForm } from "node_modules/element-ui/types/form";
import {
  Vue,
  Component,
  Prop,
  Watch,
  Provide,
  ProvideReactive,
  Inject,
  Ref
} from "vue-property-decorator";
import { default as OriginVue } from "vue";

import { clone, getCookie } from "@szgc/plt-core-v2";
import request from "../../api/request";
import wgetMgr from "../widgets/wgetMgr";
import WordWidget from "../widgets/WordWidget/index.vue";

import NtkoH5Widget from "../widgets/NtkoH5Widget/index.vue";

import LayoutRow from "./LayoutRow.vue";
import LayoutCell from "./LayoutCell.vue";
import GtMagic from "../../magic/index.vue";

import { Loading } from "element-ui";
import FileEntry from "../../file/index.vue";

import kinggrid from "../../kinggrid";

import FastIn from "./FastIn/index.vue";
import { dateFormat } from "@szgc/plt-core-v2";

import { refreshdWidgetLimitConfig } from "@/util/index";
import ContractLockWidget from "../widgets/ContractLockWidget/index.vue";

// 定义扩展接口
interface ExtendedConfig extends App.WebForm.Config {
  group?: any[];
}

// 全局注册row以及cell布局组件，需要递归嵌套，只能通过全局注册的方式引入
if (!OriginVue.component("LayoutRow")) {
  OriginVue.component("LayoutRow", LayoutRow);
}

if (!OriginVue.component("LayoutCell")) {
  OriginVue.component("LayoutCell", LayoutCell);
}

const objectKeyMap = {
  user: { nameKey: "realName", idKey: "userId" },
  role: { nameKey: "name", idKey: "id" },
  post: { nameKey: "postName", idKey: "postId" },
  department: { nameKey: "departName", idKey: "departId" },
  corporate: { nameKey: "corpName", idKey: "corpId" },
  area: { nameKey: "adFullName", idKey: "adCode" },
  dictionary: { nameKey: "dictName", idKey: "dictCode" },
  selector: { nameKey: "fieldName", idKey: "selectId" }
};

const multiType = [
  "users",
  "roles",
  "posts",
  "departments",
  "corporates",
  "areas",
  "dictionaries",
  "selectors"
];

@Component({
  name: "SzgcFormGetor",
  components: { GtMagic, FileEntry, FastIn }
})
export default class SzgcFormGetor extends Vue {
  /**
   * 运行时默认值
   * @description Object的key是数据源字段名
   * @description 优先级关系
   *    1、运行时默认值
   *    2、表单配置默认值
   *    3、数据源配置默认值
   * @example
   * {
   *   cjdw : '1001,数字分公司' // 选择类单选， 选择类组件通过逗号分割 label与value
   *   cjdws : '1001,数字分公司|1002,生态公司'   // 多选类型，由多个单选结果构成，由 | 分割
   *   xm : '张三' // 基础类型  文本、数字，日期
   *   rqfw : '16000708088,16000708088' // 日期范围使用逗号分割两个日期
   * }
   * 在cjdw 对应 widget.property.propertyName
   */
  @Prop({
    type: Object,
    default: () => ({})
    // default: () => ({lj: 'true', zsd: '11', zsc: '22', rq: '1663834197157', 'sz': '33.2', dwb: '', cwb: '', rqfw: '1663834197157,1664496000000'})
    // default: () => ({qy: '330503,中国浙江省湖州市南浔区a', dw: '100,数字工程分公司a', bm: '10007,智慧城市部.智慧能源部a', zd: 'gzh,公众号a', ry: '1000049846884761600,zhangsana', llk: 'test001,test001a', js: '3,单位管理员角色a'})
    // default: () => ({qyd: '330503,中国浙江省湖州市南浔区a', dwd: '100,数字工程分公司a', bmd: '10007,智慧城市部.智慧能源部a', zdd: '4,公众号a', ryd: '1000049846884761600,zhangsana', llkd: 'test001,test001a', jsd: '3,单位管理员角色a|4,测试'})
  })
  public runTimeFields!: { [prop: string]: string };

  @Prop({
    default: "normal"
  })
  public mode!: "preview" | "normal";

  @Ref("fileEntry")
  public fileEntry!: FileEntry;

  @Inject({ from: "client", default: "web" })
  public client!: "web" | "mobile";

  @Prop({
    type: String,
    default: ""
  })
  @Provide()
  public status!: "mine" | "todo" | "done" | "wait" | "sent" | "fine" | "term" | "cc";

  @Prop({
    required: true
  })
  @Provide("config")
  public config!: App.WebForm.ServiceOriginConfig;

  @Prop({ default: false })
  public edit!: boolean;

  public isPdfEmpty: boolean = true;

  public options: ExtendedConfig = {
    version: process.env.formConfigVersion,
    style: {
      labelPosition: "left",
      labelWidth: 80,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
      cellPaddingLeft: 10,
      cellPaddingTop: 10,
      cellPaddingRight: 0,
      cellPaddingBottom: 0,
      size: "mini",
      grid: {
        visible: false,
        color: "#000",
        width: 1,
        style: "solid"
      }
    },
    layout: [],
    widgets: [],
    businessId: "",
    businessName: "",
    pacId: "",
    group: []
  };

  @ProvideReactive("model")
  public model: any = {};
  @ProvideReactive("rules")
  public rules: any = {};
  public loading: any = null;

  // @ProvideReactive("sysconfig")
  // public sysconfig!: any;

  // @ProvideReactive("current")
  // public current!: PltUser;

  /**
   * 通过签章id查找签章widget对象
   */
  getWidgetBySignatureId(signatureId: string) {
    const widget = this.options.widgets.find((d) => {
      if (d.property.propertyType !== "stamp") return false;
      if (d.value === "" || !d.value) return false;
      const target = JSON.parse(d.value);
      return target.signatureId === signatureId;
    });
    return widget;
  }

  /**
   * 表单验证结果记录
   */
  public vmap: { [prop: string]: { result: boolean; message: string } } = {};

  /**
   * 记录每个表单项验证结果及提示信息
   */
  onFormValidate(propertyName: string, result: boolean, message: string) {
    const widget = this.options.widgets.find(
      (d) => d.isFormWidget && d.property.propertyName === propertyName
    );
    if (widget) {
      widget.vr = { result, message };
    }
  }

  /**
   * 金格签章 - 初始化及注册签章删除事件
   */
  async initSignature() {
    await kinggrid.init(this.config.businessId, this.config.businessName, (signatureid: string) => {
      this.onSignatureRemove(signatureid);
      //调用删除签章接口
      const signatureCreator = Signature.create();
      signatureCreator.removeSignature(this.config.businessId, signatureid);
      return true;
    });
  }
  private unWatch!: () => void;

  // @Watch("config", { immediate: true, deep: true  })
  /**
   * @override 欧君仁杰 2025.5.27 改动，之前onConfigChange可多次执行， 并不清楚多次执行的原型，* 现在onConfigChange只执行一次，此次改动是为了解决自定义组件直接设置config的值，引起的其他表单组* 件又变回初始值的问题
   * @description 监听表单配置的变化
   *
   */
  public async onConfigChange() {
    if (!this.config.formRenderData || this.config.formRenderData === "") {
      return;
    }

    // 在使用组件配置之前，重新查询组件对应的数据源的configValue并更新
    const options = await refreshdWidgetLimitConfig(this.config);

    // 非PDF审核流程
    if (this.config.packageType !== 2) {
      this.initFormRules(options.widgets);
      this.initFormModels(options.widgets);

      this.options = options;

      this.htmlOptions.options = options;
      if (this.options.layout) {
        this.htmlOptions.isHtml = false;
      } else {
        this.htmlOptions.isHtml = true;
      }
      // 如果启用电子签章功能，初始化电子签章
      if (window.SignatureEnable) {
        // 签章功能需要在入口页面添加金格相关的资源
        // 过滤表单组件，如果存在签章组件，加载金格签章组件资源
        // 初始化对应的Signature
        const stampWidgets = options.widgets.filter((d) => d?.property?.propertyType === "stamp");

        /**
         * 判断表单中是否使用了 金格电子签章组件，并且系统启用了电子签章
         * 符合以上条件再进行电子签章的初始化工作
         */
        if (stampWidgets.length > 0 && window["Signature"]) {
          await this.initSignature();
          this.loadSignatureList();
        }
      }
    }

    if (this.unWatch) {
      this.unWatch();
    }
  }

  @Provide()
  widgetMode = this.mode;

  @ProvideReactive("htmlOptions")
  htmlOptions = {
    options: this.options,
    model: this.model,
    isHtml: true
  };

  @Provide("originDataFn")
  originDataFn() {
    return this.config;
  }

  initChildrenWidget(widget: App.WebForm.Widget, auths: any) {
    let map;

    if (widget.value.length) {
      map = widget.value.map((i: any) => {
        const widgets: App.WebForm.Widget[] = [];
        const cid: string = Math.random().toString().slice(-4);
        const children = clone(widget.children);

        children.forEach((d: App.WebForm.Widget) => {
          const origin = i[d.property.propertyName];

          d.value = origin?.value || "";

          d.id += d.id.includes(":") ? "" : `:${cid}`;

          // d.visible = true;
          d.readonly = true;

          if (auths && auths[d.property.propertyName]) {
            d.visible = auths[d.property.propertyName].read;
            d.required = auths[d.property.propertyName].required;
          }

          // TODO 添加edti全局权限
          if (this.edit) {
            d.readonly = false;
          } else {
            if (
              auths &&
              auths[d.property.propertyName] &&
              auths[d.property.propertyName].write === true
            ) {
              d.readonly = false;
            }
          }

          const w = Object.assign(
            {
              isSubWidget: true,
              parentWidgetId: widget.id,
              wid: d.id,
              loop: cid
            },
            d
          );

          if (origin?.object) {
            w.ext = origin?.object;
          }

          w.pac = {
            pacId: this.config.pacId,
            businessId: this.config.businessId,
            reqToken: this.config.reqToken
          };

          widgets.push(w);
        });

        return widgets;
      });
    } else {
      const cid: string = Math.random().toString().slice(-4);
      const children = clone(widget.children);

      map = [
        children.map((i: App.WebForm.Widget) => ({
          ...i,
          id: i.id + `:${cid}`,
          parentWidgetId: widget.id,
          wid: i.id,
          loop: cid
        }))
      ];
    }
    widget.widgetList = map;
  }

  public initFormModels(widgets: App.WebForm.Widget[]) {
    const model: any = {};
    const { results, auths } = this.config;
    widgets.map((d) => {
      if (d.isFormWidget) {
        if (d.property.propertyType === "children") {
          d.value = results ? clone(results[d.property.propertyName].children) : "";
          this.initChildrenWidget(d, auths[d.property.propertyName].children);
        } else {
          if (results) {
            const result: any = this.initRunTimeFields(results, d.property);

            model[d.property.propertyName] = result?.value || "";
            d.ext = result.object ? result.object : {};

            if (result.value) {
              d.value = result.value;
            }

            if (d.property.propertyType === "numerical") {
              if (result.value) {
                d.value = Number(result.value);
                model[d.property.propertyName] = Number(result.value);
              }
            }
          } else {
            model[d.property.propertyName] = d.value;
          }

          d.pac = {
            pacId: this.config.pacId,
            businessId: this.config.businessId,
            reqToken: this.config.reqToken
          };
        }

        // d.visible = true;
        this.initWidgetAuth(d, auths);

        // d.readonly = true;

        d.vr = {
          result: true,
          message: ""
        };
      } else {
        // 处理文字控件的数据绑定
        if (d.type === "LabelWidget" && this.config.results) {
          const w = d as App.WebForm.LabelWidget;
          w.visible = true;
          if (w.propertyName) {
            const field = this.config.results[w.propertyName];
            w.ext = field;
          }
        }
      }
    });    
    this.model = model;
    this.htmlOptions.model = model;
  }

  initWidgetAuth(d: App.WebForm.Widget, auths: any) {
    d.readonly = true;
    if (auths && auths[d.property.propertyName]) {      
      d.visible = auths[d.property.propertyName].read;
      d.required = auths[d.property.propertyName].required;
    }

    // TODO 添加edti全局权限
    if (this.edit) {      
      d.readonly = false;
    } else {
      if (
        auths &&
        auths[d.property.propertyName] &&
        auths[d.property.propertyName].write === true
      ) {
        d.readonly = false;
      }
    }

    if (d.property.propertyType === "children" && auths[d.property.propertyName].children) {
      d.tReadonly = d.readonly;
      d.widgetList.forEach((widgetList: App.WebForm.Widget[]) => {
        widgetList.forEach((w) => {
          this.initWidgetAuth(w, auths[d.property.propertyName].children);
        });
      });
    }
  }

  public initRunTimeFields(results: any, property: any) {
    const result = { ...results[property.propertyName] };
    if (
      this.status === "mine" &&
      Object.prototype.hasOwnProperty.call(this.runTimeFields, property.propertyName) &&
      this.runTimeFields[property.propertyName]
    ) {
      const val = this.runTimeFields[property.propertyName];

      const valToArr = val.split("|").map((i) => i.split(","));
      if (multiType.includes(property.propertyType)) {
        result.object = valToArr.map((i) => {
          const o: any = {};
          o[(objectKeyMap as any)[property.propertyType.slice(0, -1)]?.idKey] = i[0];
          o[(objectKeyMap as any)[property.propertyType.slice(0, -1)]?.nameKey] = i[1];

          return o;
        });
        if (property.propertyType.startsWith("dictionar")) {
          const dictType = JSON.parse(property.configValue).value;
          result.value = dictType + ":" + valToArr.map((i) => i[0]).join();
          result.object = valToArr.map((i) => {
            const o: any = {};
            o.dictCode = i[0];
            o.dictName = i[1];
            o.typeCode = dictType;

            return o;
          });
        } else if (property.propertyType.startsWith("area")) {
          result.value = valToArr.map((i) => i[0]).join("|");
        } else {
          result.value = valToArr.map((i) => i[0]).join();
        }
      } else if (Object.prototype.hasOwnProperty.call(objectKeyMap, property.propertyType)) {
        let dictType: any;
        if (property.propertyType === "dictionary") {
          dictType = JSON.parse(property.configValue).value;
        }
        const map = valToArr.map((i) => {
          const o: any = {};
          o[(objectKeyMap as any)[property.propertyType]?.idKey] = i[0];
          o[(objectKeyMap as any)[property.propertyType]?.nameKey] = i[1];
          dictType && (o.typeCode = dictType);

          return o;
        });
        result.object = map[0];
        result.value = (dictType ? dictType + ":" : "") + valToArr[0][0];
      } else if (property.propertyType === "dateScope" && valToArr[0][0]) {
        result.value = `yyyy-MM-dd;${dateFormat(Number(valToArr[0][0]), "YYYY-MM-DD")};${dateFormat(
          Number(valToArr[0][1]),
          "YYYY-MM-DD"
        )}`;
        result.object = {
          format: null,
          begin: Number(valToArr[0][0]),
          beginTime: Number(valToArr[0][0]),
          end: Number(valToArr[0][1]),
          endTime: Number(valToArr[0][1])
        };
      } else {
        result.value = result.object = val;
      }
    }

    return result;
  }

  @Watch("edit")
  onEditChange() {
    const { auths } = this.config;
    this.options.widgets.forEach((d) => {
      d.readonly = true;
      if (this.edit) {
        d.readonly = false;
      } else {
        if (auths && auths[d.property.propertyName].write === true) {
          d.readonly = false;
        }
      }
    });
  }

  public initFormRules(widgets: App.WebForm.Widget[]) {
    const { auths } = this.config;

    widgets.map((d) => {
      if (auths && auths[d?.property?.propertyName] && d.rules?.length && d.rules.length > 0) {
        this.rules[d.property.propertyName] = d.rules.map((i) => ({
          ...i,
          required: auths[d.property.propertyName].required
          // trigger: "blur"
        }));
      }
    });
  }

  public cellStyle(isLastRow: boolean, isLastCol: boolean) {
    const {
      options: { style }
    } = this;
    return {
      paddingLeft: style.cellPaddingLeft + "px",
      paddingTop: style.cellPaddingTop + "px",
      paddingRight: style.cellPaddingRight + "px",
      paddingBottom: style.cellPaddingBottom + "px",
      ...(style.grid.visible
        ? {
            borderColor: style.grid.color,
            borderStyle: style.grid.style,
            borderTopWidth: style.grid.width + "px",
            borderBottomWidth: isLastRow ? style.grid.width + "px" : 0,
            borderLeftWidth: style.grid.width + "px",
            borderRightWidth: isLastCol ? style.grid.width + "px" : 0
          }
        : {})
    };
  }

  /**
   * 签章删除回调，重置widget对象的value属性
   */
  onSignatureRemove(signatureId: string) {
    const widget = this.options.widgets.find((d) => {
      if (d.property.propertyType !== "stamp") return false;
      if (!d.value) return false;
      const signature = JSON.parse(d.value);
      return signature.signatureId === signatureId;
    });
    if (!widget) return;
    this.$set(widget, "value", "");
  }

  /**
   * 加载已保存的签章数据
   */
  loadSignatureList() {
    this.loading = Loading.service({
      lock: true,
      fullscreen: true,
      text: "加载中..."
    });

    if (this.config.packageType !== 2) {
      const stampWidgets = this.options.widgets.filter((d) => {
        if (d.property.propertyType === "stamp") {
          return d.value && d.value !== "";
        }
        return false;
      });
      if (stampWidgets.length === 0) {
        this.loading.close();
        return;
      }
    }

    const that = this;
    // 保证表单页面渲染完毕
    setTimeout(async () => {
      const signatureCreator = Signature.create();
      await signatureCreator.getSaveSignatures(
        this.config.businessId,
        function (signs: any) {
          that.loading.close();
          var signdata: any[] = [];
          var jsonList = eval("(" + signs + ")");
          for (var i = 0; i < jsonList.length; i++) {
            var map: any = {};
            map.signatureid = jsonList[i]["signatureId"];
            map.signatureData = jsonList[i]["signature"];
            signdata.push(map);
          }
          Signature.loadSignatures(signdata, null);
          that.handleStampReadonly();
        },
        function () {
          that.loading.close();
        }
      );
    }, 1000);
  }

  /*给readonly签章添加禁止鼠标事件*/
  handleStampReadonly() {
    const readonlyArr: any[] = [];
    this.options.widgets.map((widget: any) => {
      if (widget.type === "StampWidget") {
        if (widget.value && widget.readonly) {
          readonlyArr.push(JSON.parse(widget.value).signatureId);
        }
      }
    });
    const nodes: any = document.querySelectorAll(".kg-img-div");
    for (let i = 0; i < nodes.length; i++) {
      for (let j = 0; j < readonlyArr.length; j++) {
        if (nodes[i].getAttribute("signatureid") + "" === readonlyArr[j] + "") {
          nodes[i].style.pointerEvents = "none";
        }
      }
    }
  }

  /**
   * 保存单个签章
   */
  saveSingleSignature(signid: any, signdata: any, signature: any): Promise<boolean> {
    return new Promise((resolve) => {
      let widget = this.getWidgetBySignatureId(signid);
      if (!widget) {
        resolve(false);
      } else {
        signature.saveSignature(this.config.businessId, signid, signdata, (result: boolean) => {
          resolve(result);
        });
        // }
      }
    });
  }

  /**
   * 获取所有签章并进行单个保存
   */
  async saveSignatureList() {
    const signatureCreator = Signature.create();
    const list = Signature.list;
    const keys: any[] = [];
    for (let key in list) {
      keys.push(key);
    }
    //只保存和组件值相同的的签章
    const saveKeys: any[] = [];
    this.options.widgets.map((widget: any) => {
      if (widget.type === "StampWidget") {
        if (widget.value) {
          keys.map((key: any) => {
            if (key === JSON.parse(widget.value).signatureId) {
              saveKeys.push(key);
            }
          });
        }
      }
    });
    //保存签章
    let result = true;
    for (let i = 0; i < saveKeys.length; i++) {
      const k = saveKeys[i];
      const signature = list[k].getSignatureData();
      const saveResult = await this.saveSingleSignature(k, signature, signatureCreator);
      if (!saveResult) {
        result = false;
      }
    }
    return result;
  }

  /**
   * 校验签章有效性
   */
  validateSignatureList() {
    const result = Signature.verify() as any[];
    if (result.length > 0) {
      const signids: Set<string> = new Set<string>();
      result.forEach((d) => {
        const dom = document.querySelector('[signatureid="' + d.signatureid + '"]');
        if (dom) {
          signids.add(d.signatureid);
        }
      });
      const widgets: App.WebForm.Widget[] = [];
      signids.forEach((d) => {
        const widget = this.getWidgetBySignatureId(d);
        if (widget) {
          widgets.push(widget);
        }
      });
      if (widgets.length === 0) {
        return true;
      }
      const message = widgets.map((d) => "[" + d.name + "]").join(",");
      this.$alert(message + "验证失败，请重新签署", {
        title: "提示",
        type: "error"
      });
      return false;
    }
    return true;
  }

  /**
   * 获取后台需要的签章数据，并计算签章位置信息
   */
  getSignatureValue(widget: App.WebForm.StampWidget) {
    const value = widget.value;
    if (!value || value === "") return value;
    const target = JSON.parse(value);
    const dom = document.querySelector(
      "[signatureid='" + target.signatureId + "']"
    ) as HTMLDivElement;
    if (!dom) return value;
    const marginTop = dom.style.marginTop.replace("px", "");
    const marginLeft = dom.style.marginLeft.replace("px", "");
    target.marginLeft = marginLeft;
    target.marginTop = marginTop;
    return JSON.stringify(target);
  }

  /**
   * 获取表单组件值
   */
  public getFormValues(isValid: boolean = true): Promise<{ valid: boolean; data: any }> {
    // console.log("获取表单数据");
    return new Promise((resolve) => {
      //   console.log(this.config);
      if (this.config.packageType === 2) {
        this.fileEntry.getFormValues().then((res) => {
          resolve(res);
        });
      } else {
        this.getTemplateValues(isValid).then((res) => {
          resolve(res);
        });
      }
    });
  }

  public getTemplateValues(isValid: boolean): Promise<{ valid: boolean; data: any }> {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve) => {
      for (let i = 0; i < this.options.widgets.length; i++) {
        const widget = this.options.widgets[i];
        if (widget.type === "WordWidget") {
          const component = wgetMgr.getWidgetById(widget.id) as WordWidget;
          if (component.isEditing) {
            this.$alert("请将文档关闭后再执行此操作", {
              title: "操作失败",
              type: "error"
            });
            return resolve({
              valid: false,
              data: null
            });
          }
        }
      }

      const form = this.$refs.form as ElForm;
      let valid: any;

      if (isValid) {
        valid = await form.validate();
      }
      this.loading = Loading.service({
        fullscreen: true,
        text: "加载中..."
      });
      let stampFlag: boolean = true;

      if (!isValid || valid) {
        let data: { [prop: string]: any } = {};
        this.options.widgets.forEach((d) => {
          if (d.isFormWidget) {
            const outPropertyName = d.property.propertyName;
            data[outPropertyName] = {
              children: d.widgetList?.map((i: App.WebForm.Widget) =>
                i.reduce((prev: any, cur: App.WebForm.Widget) => {
                  const propertyName = cur.property.propertyName;
                  prev[propertyName] = {};
                  prev[propertyName].value = cur.value;
                  prev[propertyName].type = cur.property.propertyType;
                  return prev;
                }, {})
              ),
              type: d.property.propertyType,
              value: d.property.propertyType === "children" ? "" : this.model[outPropertyName]
            };
            // 处理签章组件并校验签章是否必填(之前没有校验签章是否必填)
            if (d.property.propertyType === "stamp") {
              // 计算签章位置并保存
              const value = this.getSignatureValue(d as App.WebForm.StampWidget);
              data[d.property.propertyName] = {
                type: d.property.propertyType,
                value
              };
              if (d.required) {
                if (!d.value) {
                  stampFlag = false;
                }
              }
            }

            // 处理软航电子签章取值问题
            // 在软航客户端重新上传文件后，value值无法更新，从NtkoWidget.ext中获取
            if (d.property.propertyType === "hr_sign") {
              data[outPropertyName].value = d.ext.attId || "";
            }

            // 处理航软H5签章
            if (d.property.propertyType === "rh_h5_sign") {
              // 当组件处于可编辑状态 且 value !== ""时，需要校验签章是否已经签署
              const ntkoH5Widget = wgetMgr.getWidgetById(d.id) as NtkoH5Widget;

              if (
                ntkoH5Widget &&
                ntkoH5Widget.widget &&
                !ntkoH5Widget.widget.readonly &&
                ntkoH5Widget.widget.required
              ) {
                if (!ntkoH5Widget.signed) {
                  // 如果是必填，必须要进行签章后才能提交
                  this.$alert("请对文档签章后再提交", "提示", { type: "error" });
                  resolve({
                    valid: false,
                    data: null
                  });
                }
              }
            }
            // 处理航软H5签章
            if (d.property.propertyType === "contract_lock") {
              // 当组件处于可编辑状态 且 value !== ""时，需要校验签章是否已经签署
              const contractLockWidget = wgetMgr.getWidgetById(d.id) as ContractLockWidget;

              if (
                contractLockWidget &&
                contractLockWidget.widget &&
                !contractLockWidget.widget.readonly &&
                contractLockWidget.widget.required
              ) {
                if (!contractLockWidget.signed) {
                  // 如果是必填，必须要进行签章后才能提交
                  this.$alert("请对文档签章后再提交", "提示", { type: "error" });
                  resolve({
                    valid: false,
                    data: null
                  });
                }
              }
            }
            //处理自定义组件  !!!!TODO
            if (d.property.propertyType === "comHtml") {
              const definedComponent = wgetMgr.getWidgetById(d.id) as any;
              if (definedComponent) {
                const definedData = definedComponent.getFormValues();
                if (definedData.valid) {
                  const definedForm = definedData.data;
                  data = {
                    ...data,
                    ...definedForm
                  };
                } else {
                  console.log("自定义表单填写有误，请检查");
                  resolve({
                    valid: false,
                    data: null
                  });
                }
              }
            }
          }
        });
        if (!stampFlag) {
          this.loading.close();
          this.$message.error("未进行签章");
          return false;
        }
        // 如果启用了签章，需要对签章数据进行处理
        // 1、检验签章有效性
        // 2、存储签章
        if (window.SignatureEnable) {
          const result = this.validateSignatureList();
          if (!result) {
            return resolve({
              valid: false,
              data: null
            });
          }
          this.saveSignatureList().then((result) => {
            if (result) {
              this.loading.close();
              resolve({
                valid: true,
                data: { ...data }
              });
            } else {
              this.loading.close();
              resolve({
                valid: false,
                data: null
              });
            }
          });
        } else {
          // 没有使用签章，直接返回数据
          this.loading.close();
          resolve({
            valid: true,
            data: { ...data }
          });
        }
      } else {
        this.loading.close();
        resolve({
          valid: false,
          data: null
        });
      }
    });
  }

  async getPltConfig() {
    const config = sessionStorage.getItem("PLT_CONFIG");
    if (!config || config === "") {
      const prefix = getCookie("plt-api-route") || "";
      const result = await request({
        url: `${prefix}/secure/current`,
        method: "get"
      });
      if (result.success) {
        sessionStorage.setItem("PLT_CONFIG", JSON.stringify(result.data));
        // this.sysconfig = result.data;
      }
    }
  }

  // async getCurrentUser() {
  //   const prefix = getCookie("plt-api-route") || "";
  //   const result = await request({
  //     url: `${prefix}/secure/current?_t=${Date.now()}`,
  //     method: "get"
  //   });
  //   this.current = result.data;
  // }

  created() {
    if (!localStorage.getItem("offline") || localStorage.getItem("offline") === "false") {
      this.getPltConfig();
      // this.getCurrentUser();
    }
    // onConfigChange 只在组件初始化的时候执行一次
    this.unWatch = this.$watch("config", this.onConfigChange, {
      deep: true,
      immediate: true
    });
  }

  get style() {
    if (this.htmlOptions.isHtml) {
      const css: any = {};
      const options = this.options as any;
      if (options.width) {
        css.width = options.width + "px";
      }
      return css;
    }

    const {
      options: { style }
    } = this;

    if (!style.grid.visible) return {};

    const border = `${style.grid.style} ${style.grid.width}px ${style.grid.color}`;

    return {
      // borderColor: style.grid.color,
      // borderStyle: style.grid.style,
      // borderWidth: style.grid.width + 1 + "px",
      borderLeft: border,
      borderTop: border
    };
  }
}
